export const updateAdditionalUserInfo = (info) => {

  try {

    const data = getUserProfile()
    data.user.additionalUserInfo['profile'] = info
    localStorage.setItem('profile', JSON.stringify(data))

  }
  catch (err) {

  }
}
export const setUserProfile = (data) => {

  try {

    localStorage.setItem('profile', JSON.stringify(data))

  }
  catch (err) {

  }
}

export const getUserProfile = () => {

  try {

    return JSON.parse(localStorage.getItem('profile') || 'null')

  }
  catch (err) {

  }

}

export const isUserProfileComplete = () => {

  try {

    const result = Object.keys(getUserProfile()?.user?.additionalUserInfo?.profile)?.length > 0

    return result

  }
  catch (err) {

  }

}